import { ReactNode, useEffect } from "react";
import { TargetTypes } from "../../pages/PlanOperationPage/Plan/Calendar/Vessels/constants";
import { AppState, useSelector } from "../../util/store/store";
import { aWeekMillisecond } from "../../util/varibles/constants";
import { VIEW_MODE } from "../../util/varibles/permission";
import { createFastContext } from "../createFastContext";

const SizeCalendar: React.FC<{ getWeek: (state: AppState) => { key: string, time: number }[] }> = ({ getWeek }) => {
    const weeks = useSelector(getWeek);
    const left = weeks[0].time;
    const width = weeks.length * aWeekMillisecond;
    const [calendarRef] = usePlan(state => state.calendarRef);

    useEffect(() => {
        const el = calendarRef?.();
        if (el) {
            el.style.setProperty('--calendar-left', String(left));
            el.style.setProperty('--calendar-width', String(width));
            el.style.setProperty(
                '--calendar-content-width',
                `calc((100vw - 175px) / var(--week-per-screen) * ${weeks.length})`
            );
        }
    }, [calendarRef, left, weeks.length, width])

    return null;
}

interface IState {
    isDrag: string
    startCalendar: number
    endCalendar: number
    mode: VIEW_MODE
    permission: Record<string, boolean>
    target?: TargetTypes

    calendarRef?: () => HTMLElement

    onDragOp(props: any): void
}

const {
    Provider,
    useStore: usePlan,
    setStore: setPlan,
    getStore: getPlan,
    callEvent: callEventPlan
} = createFastContext<IState, {
    setTarget: (target: TargetTypes, e: MouseEvent) => void
}>({
    isDrag: '',
    mode: VIEW_MODE.PLANNER,
    startCalendar: 0,
    endCalendar: 0,
    permission: {
    },
    onDragOp: () => null
});

const PlanProvider = ({ children, generateMenu, ...args }: {
    children: ReactNode
    generateMenu?: (target: TargetTypes) => any
} & Partial<IState>) => {

    return <Provider
        props={{ ...args }}
        event={{
            setTarget: (target, e, { set }) => {
                e.stopPropagation();
                if (e.button !== 2) {
                    set({ target: undefined })
                    return;
                }
                set({ target });
            }
        }}
    >
        {children}
    </Provider>
}

export { callEventPlan, getPlan, PlanProvider, setPlan, SizeCalendar, usePlan };
